import { useState } from 'react';
import './FlatFile.css';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CloseIcon from '@mui/icons-material/Close';
import Logger from '../../Logger';
import { FileDropZoneProps } from './FlatFileInterfaces';
import { fontSize, palette } from '../..';
import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';

const FileDropZone = ({ setSelectedFile, selectedFile, fileType }: FileDropZoneProps) => {
  // drag state
  const [dragActive, setDragActive] = useState<boolean>(false);

  // handle drag events
  const handleDrag = function (e: any) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  // triggers when file is dropped
  const handleDrop = function (e: any) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      Logger('info', e.dataTransfer.files[0], 'handleDrop');
      setSelectedFile(e.dataTransfer.files[0]);
    }
  };

  // triggers when file is selected with click
  const handleChange = function (e: any) {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      Logger('info', e.target.files[0], 'handleChange');
      setSelectedFile(e.target.files[0]);
      e.target.value = '';
    } else console.log('No file selected');
  };

  return (
    <div>
      <form
        id="form-file-upload"
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
        onSubmit={(e) => e.preventDefault()}
        style={{
          justifyContent: 'center',
          alignItems: 'center',
        }}
        className={`dropzone ${dragActive ? 'dropzone-highlighted' : ''}`}
      >
        <input
          type="file"
          id="input-file-upload"
          multiple={false}
          style={{
            fontSize: fontSize.medium,
            color: palette.primary.contrastText,
          }}
          onChange={handleChange}
          accept={fileType === 'excel' ? '.xlsx' : fileType === 'json' ? '.json' : '.csv'}
        />

        <UploadFileIcon
          sx={{
            fontSize: '2.5rem',
            color: '#5d5c5c',
            margin: ' 5px auto',
            '& .MuiSvgIcon-root': {
              fontSize: '3rem',
              color: '#3b3a3a',
              margin: ' 20px auto',
            },
            transform: 'translateY(-5px)',
          }}
        />

        <p style={{ fontSize: fontSize.medium, margin: '10px auto 15px auto' }}>
          Drag and Drop your file here
        </p>

        <label
          htmlFor="input-file-upload"
          className="upload-button"
          style={{
            fontSize: fontSize.medium,
            color: palette.secondary.contrastText,
            marginBottom: '10px',
          }}
        >
          Choose a file
        </label>

        <div
          style={{
            border: '1px solid transparent',
            // height: "50px",
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '5px',
          }}
        >
          {selectedFile ? (
            <div
              className="fileNameCard"
              style={{
                fontSize: fontSize.medium,
                color: palette.primary.contrastText,
                margin: '5px auto',
              }}
            >
              {selectedFile.name}
              <Tooltip
                title="Close"
                arrow
                slotProps={{
                  popper: {
                    sx: {
                      '& .MuiTooltip-tooltip': {
                        fontSize: '0.65rem',
                      },
                    },
                  },
                }}
              >
                <IconButton
                  size="small"
                  onClick={() => setSelectedFile(undefined)}
                  sx={{
                    color: '#3b3a3a',
                    padding: 0, 
                    marginLeft: '6px',
                    '&:hover': {
                      color: 'red', 
                      backgroundColor: 'transparent', 
                    },
                  }}
                  aria-label="close-file"
                >
                  <CloseIcon sx={{ fontSize: '1.2rem' }} />
                </IconButton>
              </Tooltip>
            </div>
          ) : null}

          {/* {dragActive && (
            <div
              id="drag-file-element"
              onDragEnter={handleDrag}
              onDragLeave={handleDrag}
              onDragOver={handleDrag}
              onDrop={handleDrop}
            ></div>
          )} */}
        </div>
      </form>
    </div>
  );
};

export default FileDropZone;
